// extracted by mini-css-extract-plugin
export default {"navigation":"iVhQV","navigation-btn":"DiCmM","navigation-btn--disable":"iGI9h","navigation-icon":"VzPEi"};